var VISIBLE_PIES_COUNT = 4;
var PIES_GAP = 80;
var PIE_WIDTH = 156;
var PIE_HEIGHT = 156;
var PIE_OFFSET = 28;
var PIE_CHART_WIDTH = 900;
var PIE_CHART_HEIGHT = 186;
export { VISIBLE_PIES_COUNT, PIE_WIDTH, PIE_HEIGHT, PIES_GAP, PIE_OFFSET, PIE_CHART_WIDTH, PIE_CHART_HEIGHT, };
